var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 24,
    viewBox: "0 0 43 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.121 0.339395C41.9528 0.436971 25.3223 10.1309 20.1418 13.3042C19.284 13.8303 18.2117 13.8303 17.3539 13.3042L0.0211044 2.75334V11.3103C-0.0293549 12.5873 -0.113456 14.5133 1.42135 15.4085L14.0909 22.7649C15.4827 23.4309 16.9839 23.7618 18.4808 23.7618C20.2721 23.7618 22.0592 23.2867 23.6571 22.3449C28.8712 19.2606 36.9363 14.5133 40.6199 12.3497C41.957 11.5564 42.7938 10.1394 42.8611 8.56122V8.54849L42.7013 0L42.1168 0.339395H42.121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo-4.4a5bd640b88459dc61cfaabcb412f86a.svg";
export { ForwardRef as ReactComponent };